import { ProviderCache } from '../ProviderCache';
export const valueProviderCache = new ProviderCache((provider, params) => provider.getValues(params));
